<template>
    <DefaultButton
        :width="width"
        :height="height"
        :background-color="backgroundColor"
        :text-color="textColor"
        :disabled="disabled"
        :class="{ withText: !iconOnly }"
        @click="e => !disabled && $emit('click', e)"
    >
        <span class="iconOuter">
            <i class="icon"><slot name="icon"></slot></i
        ></span>
        <span class="text"><slot /></span>
    </DefaultButton>
</template>
<script>
import ReChallengeIcon from "@/components/forecasts/elements/icons/ReChallengeIcon";
import CheckMarkIcon from "@/components/forecasts/elements/icons/CheckMarkIcon";
import ExportXlsIcon from "@/components/forecasts/elements/icons/ExportXlsIcon";
import DefaultButton from "@/components/forecasts/elements/form/DefaultButton";

export default {
    components: { DefaultButton, ReChallengeIcon, CheckMarkIcon, ExportXlsIcon },
    props: {
        backgroundColor: {
            type: String,
            required: false,
            default: "#515151"
        },
        textColor: {
            type: String,
            required: false,
            default: "#FFF"
        },
        width: {
            type: String,
            required: false
        },
        height: {
            type: String,
            default: "53px"
        },
        disabled: {
            type: Boolean,
            default: false
        },
        iconOnly: {
            type: Boolean,
            default: false
        }
    },
    computed: {}
};
</script>
<style scoped lang="scss">
button {
    border: none;
    border-radius: 30px;
    text-transform: uppercase;
    transition: opacity 0.3s ease;
    display: flex;
    &.withText {
        .icon {
            margin: 0 10px 0 10px;
        }
        .text {
            display: inline-block;
            margin-bottom: auto;
            margin-top: auto;
            color: white;
        }
    }
    .icon {
        background-size: cover;
        display: inline-block;
        width: 30px;
    }
    .iconOuter {
        margin-bottom: auto;
        margin-top: auto;
    }
}
</style>



// WEBPACK FOOTER //
// IconButton.vue?2330f828